import { parseWakamError } from './parseWakamError';

export type QuoteError = { key: string; error: string; statusCode?: string };

const TECHNICAL_FAILURE_HELP =
  'La tarification est momentanément indisponible, merci de réessayer dans quelques minutes.';

const isTechnicalFailure = ({ statusCode }: QuoteError) => Number(statusCode) >= 500;

export const quoteFailedUserHelp = (quoteErrors: QuoteError[] | undefined): string => {
  if (!quoteErrors?.length) return 'Merci de réessayer plus tard.';
  if (quoteErrors.some(isTechnicalFailure)) return TECHNICAL_FAILURE_HELP;
  return quoteErrors
    .map(({ error }) => parseWakamError(error) ?? error)
    .filter((message, index, messages) => messages.indexOf(message) === index)
    .join(', ');
};
